/**
 * @hidden
 */
export var ArrowDirection;
(function (ArrowDirection) {
    ArrowDirection[ArrowDirection["Down"] = -1] = "Down";
    ArrowDirection[ArrowDirection["None"] = 0] = "None";
    ArrowDirection[ArrowDirection["Up"] = 1] = "Up";
})(ArrowDirection || (ArrowDirection = {}));



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/numerictextbox/arrow-direction.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/numerictextbox/arrow-direction.js
// module chunks = 3